import React, { useEffect, useState } from 'react'
import {Link} from 'react-router-dom'
import { getHighlight } from '../Service/Api';
const Highlight = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const data = await getHighlight();
      console.log(data);
      setData(data);
    };
    getData();
  }, []);

  return (
    <>
     
        {data.length > 0 &&
                  data.map((item, index) => (
          <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`} target="_blank">{item.description} <i class="bi bi-paperclip"></i></Link>
                  ))}

          
    </>
  )
}

export default Highlight;
